import { createAPIActions } from '../../utils/redux-actions';

export const highResolutionImageryCheckout = createAPIActions('HIGH_RESOLUTION_IMAGERY_CHECKOUT');
